import { cn } from "@/lib/utils";

type CardBulletPointProps = {
    icon?: JSX.Element;
    children: React.ReactNode;
    className?: string;
    variant?: "small" | "regular" | "medium";
};

export const CardBulletPoint: React.FC<CardBulletPointProps> = ({ icon, children, className, variant = "regular" }) => {
    return (
        <div className={cn("CardBulletBox | flex gap-[8px] 2xs:gap-[10px] lg:gap-[12px] 4k:gap-[48px]", className)}>
            <div
                className={cn("relative h-[20px] max-h-[20px] min-h-[20px] w-[20px] min-w-[20px] max-w-[20px] 4k:w-[88px] 4k:h-[88px] 4k:max-w-[88px] 4k:max-h-[88px] 4k:min-w-[88px] 4k:min-h-[88px]", [
                    variant === "small" && "h-[10px] w-[10px] lg:h-[14px] lg:w-[14px] ",
                ])}
            >
                {icon}
            </div>
            <div
                className={cn(
                    "font-frutigerBold font-bold tracking-minus-2 text-white break-words",
                    "text-[13px] leading-[135%] text-shadow-card-shared-text-mobile",
                    "2xs:text-[16px]",
                    "lg:text-shadow-card-shared-text-desktop",
                    "4k:text-[72px]",
                    [variant === "small" && "text-[8px] lg:text-[12px]"],
                    [variant === "medium" && "font-frutigerRoman text-[12px] font-normal lg:text-[16px]"],
                )}
            >
                {children}
            </div>
        </div>
    );
};

export default CardBulletPoint;
